import React, { Fragment } from 'react';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { defineMessages, useIntl } from 'react-intl-next';

import { ShortcutsSection } from '@confluence/space-shortcuts/entry-points/shortcutsSection.ts';
import { SpaceViewsController } from '@confluence/space-views';
import { PageTreeLoaderOnHover } from '@confluence/page-tree/entry-points/PageTreeLoader.tsx';
import { BlogTree } from '@confluence/blog-tree/entry-points/BlogTree.tsx';
import { expVal } from '@confluence/feature-experiments';

const i18n = defineMessages({
	contributorsHeader: {
		id: 'side-navigation.space-navigation.contributors.header',
		defaultMessage: 'Contributors',
		description:
			'The text shown as a link in the Confluence space sidebar to navigate to the space contributors page.',
	},
});

export const CommonSpaceNavigationContent = ({
	showShortcutsSection,
	space,
	spaceKey,
	quick,
	homepageId,
	loading,
	isSpaceAdmin,
	isBlogNavigation,
	blogsHidden,
	pageTreeFinishedLoading,
	onDragDropSuccess,
	onContentTreeLoadComplete,
}) => {
	const { formatMessage } = useIntl();

	return (
		<>
			{expVal('confluence_space_contributors', 'isEnabled', false) && (
				<LinkMenuItem
					href={`/wiki/spaces/${spaceKey}/contributors`}
					elemBefore={<PeopleGroupIcon label="" color="currentColor" />}
					data-testid="space-contributors-link"
				>
					{formatMessage(i18n.contributorsHeader)}
				</LinkMenuItem>
			)}

			{showShortcutsSection && (
				<ShortcutsSection
					isSpaceAdmin={isSpaceAdmin}
					spaceKey={spaceKey}
					links={quick}
					spaceId={space?.id || null}
				/>
			)}

			{!loading ? (
				<div
					data-vc="pageTree"
					data-testid="pageTree"
					onMouseEnter={
						expVal('confluence_frontend_remove_hydrateonhover_pagetree', 'isEnabled', false)
							? undefined
							: PageTreeLoaderOnHover.hydrateOnHover
					}
				>
					<SpaceViewsController
						key={spaceKey} // Remount on space change to reset Space views state
						homepageId={homepageId}
						onDragDropSuccess={onDragDropSuccess}
						isPeekingFromBlogs={isBlogNavigation}
						onContentTreeLoadComplete={onContentTreeLoadComplete}
						spaceHasUserContent={space?.didContainUserContent}
						pageTreeFinishedLoading={pageTreeFinishedLoading}
					/>
				</div>
			) : (
				<Fragment />
			)}

			{!loading && !blogsHidden && (
				<BlogTree spaceKey={spaceKey} pageTreeFinishedLoading={pageTreeFinishedLoading} />
			)}
		</>
	);
};
